import { useRouter } from 'next/compat/router';

/**
 * Hook for easily retrieving params from the next router query. If the query param is an array,
 * this only returns the last value of the array.
 *
 * @example
 * ```typescript
 * // Retrieve locationId and id params from the URL
 * const { locationId, id } = useQueryParams();
 * ```
 */
export const useQueryParams = () => {
  const router = useRouter();

  if (!router) {
    return {};
  }

  return Object.entries(router.query).reduce((acc: Record<string, string>, [key, value]) => {
    if (typeof value === 'string') {
      acc[key] = value;
    } else if (Array.isArray(value)) {
      acc[key] = value[value.length - 1];
    }
    return acc;
  }, {});
};
